
import { ContractTemplate } from "../../classes";

const ContractTemplateModule = {
  namespaced: true,
  state: {
    contractTemplates: []
  },
  mutations: {
    setContractTemplates(state, contractTemplates) {
      state.contractTemplates = contractTemplates || []
    },
    updateContractTemplate(state, contractTemplate) {
      if (state.contractTemplates) {
        let index = state.contractTemplates.findIndex(i => i.objectId === contractTemplate.objectId);
        state.contractTemplates[index] = contractTemplate;

        const temp = state.contractTemplates
        state.contractTemplates = []
        state.contractTemplates = temp
      }
    },
    addContractTemplate(state, contractTemplate){
      if(state.contractTemplates && state.contractTemplates.length)
        state.contractTemplates.push(contractTemplate)
      else
        state.contractTemplates = [contractTemplate]
    },
    removeContractTemplate(state, id){
      if (state.contractTemplates) {
        let index = state.contractTemplates.findIndex(i => i.objectId === id);
        state.contractTemplates.splice(index, 1);
      }
    },
  },
  actions: {
    getContractTemplates: async ({ commit }, projectId) => {
      try{
        const data = await ContractTemplate.getContractTemplates(projectId)
        commit("setContractTemplates", data)
        return data
      }catch(error){
        throw error
      }
    },
    createContractTemplate: async ({ commit }, formData) => {
      try{
        const data = await ContractTemplate.createContractTemplate(formData)
        commit("addContractTemplate", data)
        return data
      }catch(error){
        throw error
      }
    },
    editContractTemplate: async ({ commit }, formData) => {
      try{
        const data = await ContractTemplate.editContractTemplate(formData)
        commit("updateContractTemplate", data)
        return data
      }catch(error){
        throw error
      }
    },
    removeContractTemplate: async ({ commit }, id) => {
      try{
        const data = await ContractTemplate.removeContractTemplate(id)
        commit("removeContractTemplate", id)
        return data
      }catch(error){
        throw error
      }
    },
  },
  getters: {

  },
};
export default ContractTemplateModule;
